import { render } from "./AttachReport.vue?vue&type=template&id=60b7d119"
import script from "./AttachReport.vue?vue&type=script&lang=js"
export * from "./AttachReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__